import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';

import { launchmetricsGrey } from 'Styles/theme';

export const useStyles = makeStyles(() => ({
	layoutRoot: {
		paddingTop: 50,
		paddingLeft: 50,
		paddingRight: 55
	},
	layoutRootMobile: {
		paddingTop: 30,
		paddingLeft: 20,
		paddingRight: 20
	},
	headerContainer: {
		display: 'flex',
		alignItems: 'flex-start'
	},
	headerContainerMobile: {
		flexWrap: 'wrap'
	},
	title: {
		fontSize: 38
	},
	titleMobile: {
		fontSize: 22,
		fontWeight: 'normal',
		order: 2
	},
	actionsContainer: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	actionsContainerMobile: {
		order: 1,
		flexBasis: '100%'
	},
	actionBtnLabel: {
		fontSize: 14,
		color: 'white'
	},
	actionDivider: {
		backgroundColor: launchmetricsGrey,
		margin: '0 20px',
		height: 10,
		alignSelf: 'center'
	},
	closeBasketBtn: {
		color: 'white',
		padding: 0,
		backgroundColor: grey[500] + ' !important'
	},
	closeBasketIcon: {
		fontSize: 14
	},
	basketContainer: {
		marginTop: 40
	},
	basketContainerMobile: {
		marginTop: 30
	},
	basketCounter: {
		fontSize: 14,
		marginBottom: 25
	}
}));
